(function () {
  'use strict';

  var root = document.querySelector('[data-vkh]');
  var dataEl = document.querySelector('[data-vkh-data]');
  if (!root || !dataEl) return;

  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var HATS = (D.hats || []).filter(function (h) { return h && h.id && h.img; });
  if (!HATS.length) return;
  var TEES = (D.tees || []).filter(function (t) { return t && t.colours && t.colours.length; });

  document.body.classList.add('vkp-page');

  var STORE_KEY = 'vokdit-bestel';
  var FIT_KEY = 'vokdit-fit';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var TONES = {
    wit: { swatch: '#f7f6f2', tee: '#fbfaf7' },
    sand: { swatch: '#cfbd9b', tee: '#d6c4a2' },
    swart: { swatch: '#151515', tee: '#1b1b1b' },
    pienk: { swatch: '#efbccb', tee: '#efbccb' }
  };
  function tone(h) { return TONES[h] || { swatch: '#bbb', tee: '#bbb' }; }
  var HAT_FILL = { swart: '#1b1b1b', wit: '#f5f5f2', bruin: '#6e4f37', khaki: '#b9a57c', grys: '#8a8a8a' };
  var STAGE = { swart: '#dedbd6', wit: '#efede8', bruin: '#e6ddd2', khaki: '#ebe4d4', grys: '#e4e3e0' };
  // watter hemp-kleur pas by watter pet
  var TEE_PAIR = {
    swart: ['wit', 'swart', 'sand', 'pienk'],
    wit: ['swart', 'wit', 'pienk', 'sand'],
    bruin: ['sand', 'wit', 'swart'],
    khaki: ['sand', 'swart', 'wit'],
    grys: ['swart', 'wit', 'sand']
  };
  var GROUPS = [
    { key: 'cap', label: 'Pette' },
    { key: 'emmer', label: 'Bucket hats' },
    { key: 'bos', label: 'Bos hoede' },
    { key: 'ander', label: 'Ander' }
  ];

  var items = {};
  try {
    var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    if (saved && typeof saved === 'object') items = saved;
  } catch (e) {}
  var usual = null;
  try { usual = localStorage.getItem(FIT_KEY); } catch (e) {}

  function $(s, el) { return (el || document).querySelector(s); }
  var stage = $('[data-vkh-stage]'), img = $('[data-vkh-img]'), dotsEl = $('[data-vkh-dots]');
  var titleEl = $('[data-vkh-title]'), subEl = $('[data-vkh-sub]'), pickName = $('[data-vkh-pick-name]');
  var tabsEl = $('[data-vkh-tabs]'), thumbsEl = $('[data-vkh-thumbs]'), descEl = $('[data-vkh-desc]');
  var addBtn = $('[data-vkh-add]'), addLabel = $('[data-vkh-add-label]'), addPrice = $('[data-vkh-add-price]');
  var goBtn = $('[data-vkh-go]');
  var dock = $('[data-vkh-dock]'), stackEl = $('[data-vkh-stack]'), totalEl = $('[data-vkh-total]'), shipEl = $('[data-vkh-ship]');
  var progEl = $('[data-vkh-progress]'), openBtn = $('[data-vkh-open]'), sheet = $('[data-vkh-sheet]'), linesEl = $('[data-vkh-lines]');
  var checkoutBtn = $('[data-vkh-checkout]'), cartBtn = $('[data-vkh-cart]'), errEl = $('[data-vkh-error]');
  var upBox = $('[data-vkh-up]'), fitCard = $('[data-vkh-fitcard]'), fitHat = $('[data-vkh-fit-hat]'), fitTee = $('[data-vkh-fit-tee]');
  var fitTitle = $('[data-vkh-fit-title]'), fitSub = $('[data-vkh-fit-sub]'), fitAdd = $('[data-vkh-fit-add]');
  var teeTabs = $('[data-vkh-teetabs]'), teeCols = $('[data-vkh-teecols]'), teeSizes = $('[data-vkh-teesizes]');

  // Die dok moet direk in <body> sit, anders kan die tema hom wegsteek
  if (dock && dock.parentNode !== document.body) document.body.appendChild(dock);

  function money(c) { var r = c / 100; return 'R' + (r % 1 === 0 ? r.toFixed(0) : r.toFixed(2)); }
  function buzz() { if (navigator.vibrate) { try { navigator.vibrate(12); } catch (e) {} } }
  function low(s) { return (s || '').toLowerCase(); }

  /* ---------- ikone ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  function svgPath(cls, d, fill) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 40 36');
    svg.setAttribute('class', cls);
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', d);
    p.setAttribute('fill', fill);
    svg.appendChild(p);
    return svg;
  }
  function teeSVG(fill) { return svgPath('vkp-tee', 'M14 2 L20 5 L26 2 L38 8 L34 16 L30 14 L30 34 L10 34 L10 14 L6 16 L2 8 Z', fill); }
  function hatSVG(fill, kind) {
    return svgPath('vkp-hat', kind === 'cap'
      ? 'M5 25 C5 13 12 7 20 7 C28 7 33 13 33 23 L38 25 C38 28 34 29 30 28 L5 28 Z'
      : 'M11 23 L14 10 C15 6 25 6 26 10 L29 23 L38 27 L2 27 Z', fill);
  }
  function iconFor(it) {
    if (it && it.k) return hatSVG(HAT_FILL[(it.c || '').replace('x-', '')] || '#8a8a8a', it.k);
    return teeSVG(tone(it && it.c).tee);
  }

  /* ---------- watter pet ---------- */
  var cur = 0;
  HATS.forEach(function (h, i) { if (String(h.pid) === String(D.current)) cur = i; });
  var groupsPresent = GROUPS.filter(function (g) { return HATS.some(function (h) { return h.group === g.key; }); });
  var group = HATS[cur].group;

  function inGroup(g) { return HATS.map(function (h, i) { return i; }).filter(function (i) { return HATS[i].group === g; }); }

  function hat() { return HATS[cur]; }
  function hatItem(h) {
    return items[h.id];
  }

  // soort-oortjies
  var tabBtns = groupsPresent.map(function (g) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vkh-tab';
    b.setAttribute('role', 'tab');
    b.textContent = g.label;
    b.addEventListener('click', function () {
      if (group === g.key) return;
      var list = inGroup(g.key);
      // probeer dieselfde kleur in die nuwe soort
      var same = list.filter(function (i) { return HATS[i].colour === hat().colour; })[0];
      group = g.key;
      select(same !== undefined ? same : list[0], 0);
    });
    tabsEl.appendChild(b);
    return { key: g.key, el: b };
  });
  if (groupsPresent.length < 2) tabsEl.hidden = true;

  function renderTabs() {
    tabBtns.forEach(function (t) { t.el.setAttribute('aria-selected', t.key === group ? 'true' : 'false'); });
  }

  // foto-knoppies van die pette in die soort
  function renderThumbs() {
    thumbsEl.innerHTML = '';
    var list = inGroup(group);
    dotsEl.innerHTML = '';
    list.forEach(function (i) {
      var h = HATS[i];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vkh-thumb';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', i === cur ? 'true' : 'false');
      b.setAttribute('aria-label', h.title + (h.available ? '' : ', uitverkoop'));
      if (!h.available) b.classList.add('is-out');
      var im = document.createElement('img');
      im.src = h.thumb || h.img; im.alt = ''; im.width = 72; im.height = 72; im.loading = 'lazy';
      b.appendChild(im);
      var it = hatItem(h);
      if (it) { var n = document.createElement('b'); n.textContent = it.qty; b.appendChild(n); }
      b.addEventListener('click', function () { select(i, i > cur ? 1 : -1); });
      thumbsEl.appendChild(b);
      var d = document.createElement('span');
      if (i === cur) d.className = 'is-on';
      dotsEl.appendChild(d);
    });
    dotsEl.hidden = list.length < 2;
    // laai die ander foto's vooruit
    list.forEach(function (i) { var x = new Image(); x.src = HATS[i].img; });
  }

  function showHat(dir) {
    var h = hat();
    stage.style.backgroundColor = STAGE[h.colour] || '#ece8e1';
    stage.style.aspectRatio = h.w + ' / ' + h.h;
    if (dir && !reduce) {
      img.classList.add(dir > 0 ? 'is-out-l' : 'is-out-r');
      setTimeout(function () {
        img.src = h.img;
        img.classList.remove('is-out-l', 'is-out-r');
      }, 180);
    } else {
      img.src = h.img;
    }
    img.alt = h.title;
    titleEl.textContent = h.name;
    subEl.textContent = (h.stitch ? h.stitch + ' · ' : '') + money(h.price);
    pickName.textContent = h.name;
    descEl.textContent = h.desc || '';
    descEl.hidden = !h.desc;
  }

  function select(i, dir) {
    var changed = i !== cur;
    cur = i;
    group = hat().group;
    renderTabs();
    renderThumbs();
    showHat(changed ? dir : 0);
    updateAdd();
    renderFit(true);
    if (changed && window.history && history.replaceState) {
      try { history.replaceState(history.state, '', hat().url + location.hash); } catch (e) {}
    }
  }

  // swipe tussen pette in die soort
  var sx = null, sy = null;
  stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
  stage.addEventListener('pointerup', function (e) {
    if (sx === null) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    sx = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      var list = inGroup(group), k = list.indexOf(cur), n = list.length;
      if (n < 2) return;
      var step = dx < 0 ? 1 : -1;
      select(list[(k + step + n) % n], step);
    }
  });
  stage.addEventListener('pointercancel', function () { sx = null; });

  /* ---------- bysit ---------- */
  var doneTimer = null;
  function updateAdd() {
    var h = hat();
    clearTimeout(doneTimer);
    addBtn.classList.remove('is-done');
    addPrice.textContent = money(h.price);
    if (!h.available) { addLabel.textContent = 'Uitverkoop'; addBtn.disabled = true; return; }
    addBtn.disabled = false;
    var it = hatItem(h);
    addLabel.textContent = it ? 'Nog een, vir ’n pel' : 'VokDit, ek vat hom';
  }

  function addHat(h, fromEl) {
    if (items[h.id]) items[h.id].qty += 1;
    else items[h.id] = { qty: 1, name: h.name + ' · ' + (h.stitch || ''), price: h.price, c: 'x-' + h.colour, k: h.kind };
    fly(iconFor(items[h.id]), fromEl);
  }

  addBtn.addEventListener('click', function () {
    var h = hat();
    if (!h.available) return;
    addHat(h, addBtn);
    buzz(); save(); renderAll();
    addBtn.classList.add('is-done');
    addLabel.textContent = 'In jou stapel ✓';
    doneTimer = setTimeout(updateAdd, 1100);
  });

  /* ---------- vlieg na die stapel ---------- */
  var pendingNew = false, lastFlatLen = 0;
  function fly(icon, fromEl) {
    var target = stackEl.getBoundingClientRect();
    var from = (fromEl || addBtn).getBoundingClientRect();
    var wasHidden = dock.classList.contains('is-off');
    if (reduce || wasHidden || !target.width || !document.body.animate) { pendingNew = true; return; }
    var el = document.createElement('div');
    el.className = 'vkp-fly';
    el.appendChild(icon);
    document.body.appendChild(el);
    var x0 = from.left + from.width / 2 - 17, y0 = from.top + from.height / 2 - 15;
    var x1 = target.right - 20, y1 = target.top + 4;
    var anim = el.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1.6) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 80) + 'px) scale(1.3) rotate(-12deg)', opacity: 1, offset: .45 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(1) rotate(0deg)', opacity: 1 }
    ], { duration: 620, easing: 'cubic-bezier(.3,.7,.2,1)' });
    pendingNew = 'after';
    anim.onfinish = function () { el.remove(); pendingNew = true; renderDock(); };
  }

  /* ---------- maak die fit klaar: 'n hemp by die pet ---------- */
  var tee = { t: 0, c: 0, size: null };
  var teeTouched = false;

  function recSize(sizes) {
    if (!usual) return null;
    var k = sizes.indexOf(usual);
    if (k < 0) return null;
    return sizes[Math.min(k + 1, sizes.length - 1)];
  }
  function bestTeeColour(T, hatColour) {
    var want = TEE_PAIR[hatColour] || [];
    for (var w = 0; w < want.length; w++) {
      for (var c = 0; c < T.colours.length; c++) {
        if (T.colours[c].handle === want[w] && colourAvailable(T.colours[c])) return c;
      }
    }
    for (var c2 = 0; c2 < T.colours.length; c2++) if (colourAvailable(T.colours[c2])) return c2;
    return 0;
  }
  function colourAvailable(col) {
    return Object.keys(col.variants).some(function (s) { return col.variants[s] && col.variants[s].available; });
  }
  function teeVariant() {
    var T = TEES[tee.t]; if (!T || !tee.size) return null;
    return T.colours[tee.c].variants[tee.size] || null;
  }
  function teeOwned() {
    return Object.keys(items).some(function (id) { return !items[id].k; });
  }

  if (!TEES.length) upBox.hidden = true;

  function renderFit(hatChanged) {
    if (!TEES.length) return;
    var T = TEES[tee.t], h = hat();
    if (hatChanged && !teeTouched) tee.c = bestTeeColour(T, h.colour);
    if (!tee.size) tee.size = recSize(T.sizes);
    var col = T.colours[tee.c];

    // oortjies vir Represent / Embroidered
    teeTabs.innerHTML = '';
    if (TEES.length > 1) {
      TEES.forEach(function (x, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vkh-teetab';
        b.textContent = x.short;
        b.setAttribute('aria-pressed', i === tee.t ? 'true' : 'false');
        b.addEventListener('click', function () {
          if (i === tee.t) return;
          var name = TEES[tee.t].colours[tee.c].handle;
          tee.t = i;
          var same = -1;
          TEES[i].colours.forEach(function (c, k) { if (c.handle === name) same = k; });
          tee.c = same >= 0 ? same : bestTeeColour(TEES[i], hat().colour);
          renderFit(false);
        });
        teeTabs.appendChild(b);
      });
    }

    // kleure
    teeCols.innerHTML = '';
    T.colours.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vkp-sw vkh-sw';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', i === tee.c ? 'true' : 'false');
      b.setAttribute('aria-label', c.name);
      var dot = document.createElement('i');
      dot.style.background = tone(c.handle).swatch;
      b.appendChild(dot);
      b.disabled = !colourAvailable(c);
      b.addEventListener('click', function () { tee.c = i; teeTouched = true; renderFit(false); });
      teeCols.appendChild(b);
    });

    // sizes
    teeSizes.innerHTML = '';
    var rec = recSize(T.sizes);
    T.sizes.forEach(function (s) {
      var v = col.variants[s];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vkp-size vkh-size';
      b.setAttribute('role', 'radio');
      b.textContent = s;
      b.disabled = !(v && v.available);
      b.setAttribute('aria-checked', tee.size === s ? 'true' : 'false');
      b.classList.toggle('is-rec', rec === s);
      var q = v && items[v.id] ? items[v.id].qty : 0;
      var cnt = document.createElement('b'); cnt.textContent = q ? '×' + q : ''; b.appendChild(cnt);
      b.addEventListener('click', function () { tee.size = s; renderFit(false); });
      teeSizes.appendChild(b);
    });

    fitHat.src = h.thumb || h.img; fitHat.alt = h.title;
    fitTee.src = col.front; fitTee.alt = T.short + ' in ' + col.name;

    var done = teeOwned();
    fitCard.classList.toggle('is-done', done);
    if (done) {
      fitTitle.textContent = 'Fit klaar.';
      fitSub.textContent = 'Hemp en ' + (h.kind === 'cap' ? 'pet' : 'hoed') + ' is in. Dis nie vir almal nie.';
    } else {
      fitTitle.textContent = 'Maak die fit klaar';
      fitSub.textContent = '’n ' + col.name + ' ' + T.short + ' by die ' + low(h.name) + '? Dit werk. Dan is aflewering ook gratis.';
    }

    var v = teeVariant();
    fitAdd.innerHTML = '';
    var label;
    if (!tee.size) { label = 'Kies ’n size vir die hemp'; fitAdd.disabled = true; }
    else if (!v || !v.available) { label = 'Die size is uitverkoop'; fitAdd.disabled = true; }
    else {
      fitAdd.disabled = false;
      label = (done ? 'Nog ’n hemp' : 'Sit die hemp by') + ' · ' + tee.size;
    }
    fitAdd.appendChild(document.createTextNode(label));
    var sp = document.createElement('span'); sp.textContent = money(v ? v.price : T.price); fitAdd.appendChild(sp);
  }

  fitAdd.addEventListener('click', function () {
    var T = TEES[tee.t], col = T.colours[tee.c], v = teeVariant();
    if (!v || !v.available) return;
    if (items[v.id]) items[v.id].qty += 1;
    else items[v.id] = { qty: 1, name: T.short + ' · ' + col.name + ' ' + tee.size, price: v.price, c: col.handle, s: tee.size };
    // onthou die size vir die hemp-bladsy
    if (!usual) {
      var k = T.sizes.indexOf(tee.size);
      usual = T.sizes[Math.max(k - 1, 0)];
      try { localStorage.setItem(FIT_KEY, usual); } catch (e) {}
    }
    fly(iconFor(items[v.id]), fitTee);
    buzz(); save(); renderAll();
  });

  /* ---------- dok ---------- */
  function totals() {
    var count = 0, sum = 0;
    Object.keys(items).forEach(function (id) { count += items[id].qty; sum += items[id].qty * items[id].price; });
    return { count: count, sum: sum };
  }

  function renderDock() {
    var t = totals();
    var wasOff = dock.classList.contains('is-off');
    dock.classList.toggle('is-off', t.count === 0);
    if (wasOff && t.count && !reduce) { checkoutBtn.classList.remove('is-nudge'); void checkoutBtn.offsetWidth; checkoutBtn.classList.add('is-nudge'); }
    goBtn.hidden = t.count === 0;
    if (t.count) {
      goBtn.innerHTML = '';
      goBtn.appendChild(document.createTextNode('Gaan betaal'));
      var gs = document.createElement('span');
      gs.textContent = t.count + (t.count === 1 ? ' item · ' : ' items · ') + money(t.sum);
      goBtn.appendChild(gs);
    }
    document.body.classList.toggle('vkp-has-dock', t.count > 0);
    if (!t.count) { setSheet(false); return; }
    var free = t.count >= 2 || t.sum >= 59900;
    totalEl.textContent = money(t.sum);
    if (!checkoutBtn.disabled) checkoutBtn.textContent = 'Checkout · ' + money(t.sum);
    shipEl.textContent = t.count + (t.count === 1 ? ' item' : ' items') + (free ? ' · gratis aflewering' : ' · nog een en aflewering is gratis');
    shipEl.classList.toggle('is-free', free);
    progEl.style.width = free ? '100%' : '50%';
    progEl.classList.toggle('is-full', free);

    if (pendingNew === 'after') return; // wag tot die ikoon geland het
    var flat = [];
    Object.keys(items).forEach(function (id) { for (var k = 0; k < items[id].qty; k++) flat.push(items[id]); });
    var prevCount = lastFlatLen; lastFlatLen = flat.length;
    stackEl.innerHTML = '';
    var show = flat.slice(-4);
    show.forEach(function (it, k) {
      var s = iconFor(it);
      if (pendingNew === true && k === show.length - 1 && flat.length > prevCount) s.classList.add('is-new');
      stackEl.appendChild(s);
    });
    if (flat.length > 4) { var em = document.createElement('em'); em.textContent = '+' + (flat.length - 4); stackEl.appendChild(em); }
    pendingNew = false;
    renderLines();
  }

  function renderLines() {
    linesEl.innerHTML = '';
    Object.keys(items).forEach(function (id) {
      var it = items[id];
      var li = document.createElement('li');
      li.appendChild(iconFor(it));
      var nm = document.createElement('span');
      nm.className = 'vkp-line-name';
      nm.textContent = it.name.split(' · ')[0];
      var sm = document.createElement('small');
      sm.textContent = it.name.split(' · ')[1] || '';
      nm.appendChild(sm);
      var q = document.createElement('span');
      q.className = 'vkp-qty';
      var m = document.createElement('button'); m.type = 'button'; m.textContent = '−'; m.setAttribute('aria-label', 'Een minder');
      var n = document.createElement('span'); n.textContent = it.qty;
      var p = document.createElement('button'); p.type = 'button'; p.textContent = '+'; p.setAttribute('aria-label', 'Een meer');
      m.addEventListener('click', function () { it.qty -= 1; if (it.qty <= 0) delete items[id]; save(); renderAll(); });
      p.addEventListener('click', function () { it.qty += 1; save(); renderAll(); });
      q.appendChild(m); q.appendChild(n); q.appendChild(p);
      li.appendChild(nm); li.appendChild(q);
      linesEl.appendChild(li);
    });
  }

  function setSheet(open) {
    sheet.hidden = !open;
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var cr = openBtn.querySelector('.vkp-dock-caret'); if (cr) cr.textContent = open ? 'Maak toe' : 'Wys';
  }
  openBtn.addEventListener('click', function () { setSheet(sheet.hidden); });

  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(items)); } catch (e) {} }

  function renderAll() {
    renderDock();
    renderThumbs();
    if (!addBtn.classList.contains('is-done')) updateAdd();
    renderFit(false);
  }

  /* ---------- checkout ---------- */
  function send(dest) {
    var payload = Object.keys(items).map(function (id) { return { id: Number(id), quantity: items[id].qty }; });
    if (!payload.length) return;
    checkoutBtn.disabled = true; cartBtn.disabled = true;
    checkoutBtn.textContent = 'Een oomblik';
    errEl.hidden = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: payload })
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || '');
      items = {}; save();
      window.location.href = dest;
    }).catch(function (err) {
      checkoutBtn.disabled = false; cartBtn.disabled = false; goBtn.disabled = false;
      checkoutBtn.textContent = 'Checkout · ' + money(totals().sum);
      errEl.textContent = (err && err.message) ? err.message : 'Kon nie by checkout uitkom nie. Probeer weer, of WhatsApp ons op 064 788 6142.';
      errEl.hidden = false;
    });
  }
  checkoutBtn.addEventListener('click', function () { send('/checkout'); });
  goBtn.addEventListener('click', function () { goBtn.disabled = true; send('/checkout'); });
  cartBtn.addEventListener('click', function () { send('/cart'); });

  window.addEventListener('pageshow', function () {
    checkoutBtn.disabled = false; cartBtn.disabled = false; goBtn.disabled = false;
    checkoutBtn.textContent = 'Checkout · ' + money(totals().sum);
    try { var s = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}'); if (s && typeof s === 'object') items = s; } catch (e) {}
    renderAll();
  });

  /* ---------- begin ---------- */
  renderTabs();
  renderThumbs();
  showHat(0);
  updateAdd();
  renderFit(true);
  renderDock();
})();
